export default __webpack_public_path__ + "e99f10a208160d8adfa15c14a70f6b35.png";